import { FunctionComponent } from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "@/components/Icon/Icon";
import { Spinner } from "@/components/Spinner/Spinner";
import { classNames } from "@/utils/classNames";

import { FooterPopoverItem } from "../utils/editorFooter.types";

const CREATE_ICON_CLASSES = "bg-background-light text-text-meta border border-border-light";

interface PopoverItemRowProps {
	item: FooterPopoverItem;
	icon: IconDefinition;
	/** Background/text colors of the icon wrap, per popover kind. */
	iconWrapClassName: string;
}

/** One row of an insert popover: icon, name and an optional meta line. */
export const PopoverItemRow: FunctionComponent<PopoverItemRowProps> = ({
	item,
	icon,
	iconWrapClassName,
}) => (
	<div
		className={classNames(
			"w-full flex items-center gap-2.5 px-2.5 py-2 rounded-md text-left cursor-pointer hover:bg-background-light",
			item.pending && "opacity-60 pointer-events-none"
		)}
		data-test={`editor-footer-item-${item.key}`}
		role="button"
		onClick={() => {
			if (!item.pending) {
				item.onSelect();
			}
		}}
	>
		<span
			className={classNames(
				"w-[22px] h-[22px] flex-shrink-0 rounded flex items-center justify-center",
				item.isCreateAction ? CREATE_ICON_CLASSES : iconWrapClassName
			)}
		>
			{item.pending ? (
				<Spinner color="#6b7280" />
			) : (
				<Icon className="w-3 h-3" icon={item.isCreateAction ? faPlus : icon} />
			)}
		</span>

		<span className="flex-1 min-w-0">
			<span
				className={classNames(
					"block truncate text-[12.5px] font-medium",
					item.isCreateAction ? "text-text-meta" : "text-text"
				)}
			>
				{item.name}
			</span>
			{item.meta && <span className="block truncate text-xs text-text-meta">{item.meta}</span>}
		</span>
	</div>
);
